
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";

export default defineComponent({
  name: "Tickets",

  components: {},

  setup() {
    onMounted(() => {
      setCurrentPageTitle("Tickets");
    });
  },

  data() {
    return {
      publicTickets: [
        {
          title: "How to use Netronic with Django Framework?",
          label: "React",
          link: "#",
          description:
            "By KeenTHemes to save tons and more to time money projects are listed amazing outstanding projects are listed",
          icon: "success",
        },
        {
          title: "Keen Admin npm issue",
          label: "Angular",
          link: "#",
          description:
            "By KeenTHemes to save tons and more to time money projects",
          icon: "warning",
        },
        {
          title: "Metronic theme authentication to node.js / strapi backend",
          label: "warning",
          link: "#",
          description:
            "By KeenTHemes to save tons and more to time money projects",
          icon: "success",
        },
        {
          title: "How to use Metronic with Django Framework?",
          label: "HTML",
          link: "#",
          description:
            "By KeenTHemes to save tons and more to time money projects are listed amazing outstanding projects are listed",
          icon: "success",
        },
        {
          title: "Reducing footprint of Start theme",
          label: "Angular",
          link: "#",
          description:
            "By KeenTHemes to save tons and more to time money projects",
          icon: "warning",
        },
        {
          title: "Metronic theme node.js / strapi backend",
          label: "React",
          link: "#",
          description:
            "By KeenTHemes to save tons and more to time money projects are listed amazing outstanding projects are listed",
          icon: "success",
        },
        {
          title: "Keen Admin npm issue",
          label: "View",
          link: "#",
          description:
            "By KeenTHemes to save tons and more to time money projects",
          icon: "warning",
        },
        {
          title: "How to use Metronic with Django Framework?",
          label: "PHP",
          link: "#",
          description:
            "By KeenTHemes to save tons and more to time money projects are listed amazing outstanding projects are listed",
          icon: "success",
        },
      ],
      documentation: [
        {
          label: "Angular Admin",
          link: "#",
        },
        {
          label: "React Admin",
          link: "#",
        },
        {
          label: "Vue Dashboard",
          link: "#",
        },
        {
          label: "Niche Theme",
          link: "#",
        },
        {
          label: "Dashboard Admin",
          link: "#",
        },
        {
          label: "Dorsey Front-end",
          link: "#",
        },
        {
          label: "CRM Admin",
          link: "#",
        },
        {
          label: "Admin Dashbaord",
          link: "#",
        },
        {
          label: "Intranet Admin",
          link: "#",
        },
      ],
    };
  },
});
